export function initBreadcrumb() {
  const breadcrumbContainer = document.querySelector('.breadcrumbs');
  if (!breadcrumbContainer) return;

  const breadcrumbItems = breadcrumbContainer.querySelectorAll('.breadcrumbs__item');
  const breadcrumbLinks = breadcrumbContainer.querySelectorAll('.breadcrumbs__item a');

  if (breadcrumbItems.length > 0) {
    breadcrumbItems[breadcrumbItems.length - 1].classList.add('active');
  }

  breadcrumbLinks.forEach((link, index) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      window.location.href = link.href;
    });
  });
}
